package com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor

    fun Boolean.toIntString() = if (this) "1" else "0"

    sealed class ControlStyle(val style: String) {
        data class Bold(val selectedText: String?) : ControlStyle(style = "<strong>$selectedText</strong>")
        data class Italic(val selectedText: String?) : ControlStyle(style = "<em>$selectedText</em>")
        data class Underline(val selectedText: String?) : ControlStyle(style = "<span style='text-decoration: underline;'>$selectedText</span>")
        data class Link(val selectedText: String?,val url: String?,val title:String?) : ControlStyle(style = "<a href=\"$url\" title=\"$title\" target=\"_blank\">$selectedText</a>")
        data class Title(val selectedText: String?) : ControlStyle(style = "<strong><h1>$selectedText</h1></strong>")
        data class Subtitle(val selectedText: String?) : ControlStyle(style = "<strong><h3>$selectedText</h3></strong>")
        data class Quote(val selectedText: String?) : ControlStyle(style = "<q>$selectedText</q>")
        data class Paragraph(val selectedText: String?) : ControlStyle(style = "<p>$selectedText</p>")
        data class Heading(val selectedText: String?) : ControlStyle(style = "<h2>$selectedText</h2>")
        data class Youtube(val selectedText: String?, val title: String, val enabledVideoControls: Boolean = true, val autoplay: Boolean = false) : ControlStyle(style = """
            <div class="iframe-container">
              <div style="position:relative;padding-top:56.25%;">
                <iframe 
                      ## original_video_link = $selectedText"  
                      ## ?theme=light&modestbranding=1&autohide=1&showinfo=0&controls=0&rel=0&vq=hd1080&autoplay=1
                      src="${selectedText?.replace(oldValue = "https://youtu.be/", newValue = "https://www.youtube.com/embed/", ignoreCase = true)}?rel=0&color=white&showinfo=0&controls=${enabledVideoControls.toIntString()}&autoplay=${autoplay.toIntString()}"
                      title="$title"
                      style="position:absolute;top:0;left:0;width:100%;height:100%;"
                      frameborder="0" 
                      allowfullscreen
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
              </div>
            </div>
        """.trimIndent())
        data class TikTok(val selectedText: String?,val title: String,val enabledVideoControls: Boolean = true,val autoplay: Boolean = false) : ControlStyle(style = """
            <div class="iframe-container">
              <div style="position:relative;padding-top:56.25%;">
                <iframe 
                    src="https://www.tiktok.com/player/v1/${selectedText?.extractTikTokIdFromLinkOrEmbed()}?&music_info=1&description=1&autoplay=${autoplay.toIntString()}" 
                    title="$title"
                    style="position:absolute;top:0;left:0;width:100%;height:100%;"
                    frameborder="0" 
                    allowfullscreen
                ></iframe>
              </div>
            </div>
        """.trimIndent())
        data class Code(val selectedText: String?) : ControlStyle(style ="""
                <div style="
                    background-color: #474949;
                    color: #f8f8f2;
                    font-family: Consolas, monospace;
                    font-size: 14px;
                    padding: 10px;
                    border-radius: 10px;
                    overflow-x: auto;
                ">
                    <pre><code class="language-kotlin">$selectedText</code></pre>
                </div>
        """.trimIndent())

        data class Image(val selectedText: String?, val title:String) : ControlStyle(style = "<img style=\"max-width: 100%;display: block;-webkit-user-select: none;margin: auto;background-color: hsl(0, 0%, 90%);\" alt=\"$title\" src=\"$selectedText\">")


    }


